(() => {
  if (window.lvVideoShowcaseReady) return;
  window.lvVideoShowcaseReady = true;

  const buildPlaybackUrl = (source, provider, autoplay) => {
    const url = new URL(source, window.location.href);

    if (autoplay) {
      url.searchParams.set('autoplay', provider === 'bunny' ? 'true' : '1');
    }

    if (provider === 'youtube') {
      url.searchParams.set('playsinline', '1');
      url.searchParams.set('rel', '0');
    }

    return url.toString();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lv-video-play]');
    if (!button || button.disabled) return;

    const section = button.closest('[data-lv-video-showcase]');
    const player = section?.querySelector('.lv-video-showcase__player');
    const source = section?.dataset.videoSrc;
    if (!section || !player || !source) return;

    player.src = buildPlaybackUrl(
      source,
      section.dataset.provider,
      section.dataset.autoplayAfterClick === 'true'
    );
    section.classList.add('is-playing');
    button.setAttribute('aria-hidden', 'true');
    button.tabIndex = -1;
  });
})();
